module.exports = __webpack_public_path__ + "static/media/heart.77630f3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/DogProfile/heart.svg
// module id = 340
// module chunks = 0